import React from "react";
import { Box, Center, Loader, Text } from "@mantine/core";

const SmartFhirLoadingScreen: React.FC = () => (
  <div
    style={{
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "20px",
    }}
  >
    <Box style={{ maxWidth: "500px", textAlign: "center" }}>
      <Center>
        <Loader size="md" style={{ marginBottom: "16px" }} />
      </Center>
      <Text size="lg" fw={500} mb="xs">
        SMART on FHIR Getting Ready
      </Text>
      <Text size="sm" c="dimmed">
        Initializing FHIR client and establishing secure connection...
      </Text>
    </Box>
  </div>
);

export default SmartFhirLoadingScreen;
